<template>
  <div id="verificar-patrimonio">
    <nav-menu></nav-menu>

    <div 
      class="w3-main w3-animate-left w3-padding-large"
      style=" margin-top:43px;">
      <header style="padding-top:22px">
        <h5 class="w3-left  w3-col s12 m8">
          <b><i class="fa fa-building"></i>  Verificar patrimônio</b>
        </h5>
        <button 
          class="w3-button w3-theme w3-right w3-col s12 m4 l2" 
          v-on:click="mostrarModalEmpresas()">
          <b>Selecionar empresa(s)</b>
          </button>
      </header>
      
      <div class="w3-col s12 w3-margin-top" id="patrimonio"><br>
        <div class="w3-container w3-mobile" style="padding:0">  
          <p v-show="empresas_selecionadas.length == 0">Não há empresa(s) selecionada(s).</p>
        
          <div style="max-height: 200px;overflow: auto" v-show="empresas_selecionadas.length > 0">
            <table class="w3-table w3-border w3-bordered w3-striped w3-white">
              <thead>
                <tr>
                  <th style="width:70%;">Empresa</th>
                  <th style="width:30%;" class="w3-hide-small">CNPJ</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(empresa, empresa_index) in empresas_selecionadas" :key="empresa_index">
                  <td>{{empresa.empresa_id}} - {{empresa.nome_fantasia}}</td>
                  <td class="w3-hide-small">{{empresa.cnpj}}</td>
                  <td style="text-align: right">
                    <button 
                      class="w3-button w3-theme w3-tiny"
                      v-on:click="adicionarRemoverEmpresa(empresa.empresa_id, true)">
                      <i class="fa fa-times"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div><br> 
        </div>
        
        <div class="w3-row">  
          <div class="w3-col m12 l12"> 
            <div class="w3-row w3-col s12 m6  w3-padding-small metade">
              <h5 class="w3-col s12 m12 l4" >Tipo de código</h5>  
              <input 
                class="w3-radio w3-col s1" 
                v-model="tipo_filtro" 
                type="radio" 
                value="CP">
              <label 
                class="w3-col s11 m5 l3" 
                style="line-height: 43px; text-align: left"> 
                Patrimônio 
              </label>
              <input 
                class="w3-radio w3-col s1" 
                v-model="tipo_filtro"
                type="radio"
                value="CE">
              <label 
                class="w3-col s11 m5 l3"
                style="line-height: 43px; text-align: left"> 
                Plaqueta 
              </label>
            </div>
            
            <div class="w3-row w3-col s12 m6 w3-padding-small metade">
              <h5 class="w3-col s12 m12 l4">Código para pesquisa</h5>
              <input 
                class="w3-input w3-border w3-padding w3-col s12 m12 l8" 
                v-model="filtro_id" id="filtro_id" 
                type="number">       
            </div>
          </div>
          
          <div class="w3-col s12 m6 l6">
            <button 
              class="w3-btn w3-theme w3-margin-bottom w3-col s12 m11 l6"
              v-on:click="mostrarModalDepartamentos()">
              <b>Selecionar departamento(s)</b>
            </button>
          
            <p  
              class="w3-col s12 m12 l6 w3-padding" 
              style="margin:0" 
              v-show="departamentos_selecionados.length == 0">
              Não há departamentos selecionados.
            </p>
            
            <div 
              class="w3-col s12" 
              style="max-height: calc(100vh - 600px);min-height: 100px;overflow: auto" 
              v-show="departamentos_selecionados.length > 0">
              
              <table class="w3-table-all">
                <thead>
                  <tr>
                    <th style="width:20%;">Código</th>
                    <th style="width:80%;">Departamento</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(departamento, departamento_index) in departamentos_selecionados" :key="departamento_index">
                    <td>{{departamento.departamento_id}}</td>
                    <td>{{departamento.nome}}</td>
                    <td>
                      <button 
                        class="w3-button w3-theme w3-tiny"
                        v-on:click="adicionarRemoverDepartamento(departamento.departamento_id, true)">
                        <i class="fa fa-times"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div><br>
          </div> 
          
          <div class="w3-col s12 m6 l6">
            <button 
              class="w3-btn w3-theme w3-margin-bottom w3-col s12 m11 l6 " 
              v-on:click="mostrarModalUsuarios()">
              <b>Selecionar responsável(is)</b>
            </button>
            
            <p 
              class="w3-col s12 m12 l6  w3-padding" 
              style="margin:0" 
              v-show="usuarios_selecionados.length == 0">
              Não há responsável selecionado.
            </p>
            
            <div 
              class="w3-col s12" 
              style="max-height: calc(100vh - 600px);min-height: 100px;overflow: auto"
              v-show="usuarios_selecionados.length > 0">
              
              <table class="w3-table-all">
                <thead>
                  <tr>
                    <th style="width:20%;">Usuário</th>
                    <th style="width:40%;">Nome</th>
                    <th style="width:40%;" class="w3-hide-small">Empresa</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(usuario, usuario_index) in usuarios_selecionados" :key="usuario_index">
                    <td>{{usuario.funcionario_id}}</td>
                    <td>{{usuario.nome}}</td>
                    <td class="w3-hide-small">{{usuario.nome_empresa_resumido}}</td>
                    <td>
                      <button class="w3-button w3-theme w3-tiny" 
                      v-on:click="adicionarRemoverUsuario(usuario.funcionario_id, true)">
                      <i class="fa fa-times"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div><br>   
          </div>         
        </div>
        
        <div 
          class="w3-center texto-cinza w3-display-container w3-col s12 m12 w3-padding-24" 
          style="text-align:right"
          v-cloak>
          <button 
            class="w3-button w3-theme w3-col s12 m2 w3-display-middle w3-margin-top"
            v-on:click="buscarPatrimonio()"
            :disabled="processando">
            Processar
          </button>
        </div>
        
        <h5 class="titulo texto-vermelho w3-col s12 w3-margin-top" v-cloak>
          <span>Patrimônio</span>
        </h5> 
        
        <div class="w3-panel w3-col" v-if="processando">
          <p class=" w3-theme w3-card-2 w3-padding"><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
        </div>

        <div 
          class="w3-mobile"
          v-show="patrimonio_filtrado.length > 0"
          id="tabelaPatrimonios">
          
          <table class="w3-table-all w3-stripped">
            <thead>
              <tr>
                <th>Patrimônio</th>
                <th>Empresa</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                class="label-clicavel"
                v-for="(patrimonio, patrimonio_index) in patrimonio_filtrado" 
                :key="patrimonio_index"
                v-on:click="mostrarModalDetalhes(patrimonio.patrimonio_id)">
                <td>{{patrimonio.patrimonio_id}} - {{patrimonio.nome}}</td>
                <td>{{patrimonio.empresa_id}} - {{patrimonio.nome_empresa}}</td>  
              </tr>
            </tbody>
          </table><br><br>
        </div>

        <!-- Inicio modal selecionar empresa -->
        <div
          id="modalInserirEmpresas" 
          v-if="mostrarModalInserirEmpresas"
          @click="mostrarModalInserirEmpresas = false"
          style="display: block"
          class="w3-modal">
          
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span
                @click="mostrarModalInserirEmpresas = false" 
                class="w3-button w3-display-topright">
                &times;
              </span>
              <h2 class="texto-vermelho titulo">Empresas disponíveis</h2>
            </header>
            
            <div class="w3-container">
              <div class="w3-col">
                <br>
                <div 
                  class="w3-responsive" 
                  style="max-height: calc(100vh - 320px);min-height: 200px;overflow: auto">
                  <table class="w3-table-all">
                    <thead>
                      <th>Código</th>
                      <th>Nome fantasia</th>
                      <th class="w3-hide-small">CNPJ</th>
                    </thead>
                    <tbody>
                      <tr 
                        v-for="(empresa, empresa_index) in empresas_autorizadas" 
                        :key="empresa_index"
                        :class="getClasseDisponivel(empresa.adicionado)" 
                        v-on:click="adicionarRemoverEmpresa(empresa.empresa_id, empresa.adicionado)">
                        <td>{{empresa.empresa_id}}</td>
                        <td>{{empresa.nome_fantasia}}</td>
                        <td class="w3-hide-small">{{empresa.cnpj}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
            <footer class="w3-container conteudo-centralizado">
              <button 
                class="w3-btn w3-theme"
                id="btn-confirmar-acao"
                style="margin-top: 10px; margin-bottom:10px"
                @click="mostrarModalInserirEmpresas = false">
                Ok
              </button>
            </footer>
          </div>
        </div>
        <!-- Fim modal selecionar empresa -->

        <!-- Inicio modal inserir responsavel -->
        <div 
          id="modalInserirUsuarios" 
          @click="mostrarModalInserirUsuarios = false" 
          v-if="mostrarModalInserirUsuarios"
          style="display: block" 
          class="w3-modal">
          
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span
                @click="mostrarModalInserirUsuarios = false" 
                class="w3-button w3-display-topright w3-text-theme w3-large">
                &times;
              </span>
              <h2 class="texto-vermelho titulo">Usuários disponíveis</h2>
            </header>
            
            <div class="w3-container">
              <div class="w3-col">               
                <input 
                  class="w3-input w3-border w3-padding w3-col s12 m10 w3-margin-top w3-margin-bottom input-pesquisa" 
                  type="text" 
                  placeholder="Pesquise por código ou nome do usuário" 
                  autofocus v-model="filtro_usuarios" 
                  v-on:keyup="filtrarUsuarios()" 
                  id="pesquisa_usuario">
                  
                <div class="campo-check">
                  <input 
                    class="w3-check w3-margin-bottom"
                    name="fotos_usuarios" 
                    id="fotos_usuarios" 
                    type="checkbox" 
                    checked="checked" 
                    v-model="buscar_fotos_usuarios">
                    
                  <label for="fotos_usuarios"><strong>Mostrar fotos</strong></label>
                </div> 
                
                <div 
                  class="w3-responsive w3-border  w3-col s12"
                  style="max-height: calc(100vh - 320px);min-height: 200px;overflow: auto">
                  <table class="w3-table-all">
                    <thead>
                      <th v-if="buscar_fotos_usuarios"></th>
                      <th>Usuário</th>
                      <th>Nome</th>
                      <th class="w3-hide-small">Empresa</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(usuario, usuario_index) in usuarios_disponiveis_filtrados" 
                        :key="usuario_index" 
                        :class="getClasseDisponivel(usuario.adicionado)">
                        
                        <td 
                          v-on:click="mostrarModalFotoFuncionario(usuario.funcionario_id)" 
                          v-if="buscar_fotos_usuarios" class="w3-animate-left">
                          <img 
                            :style="`width: 3rem; 
                            height: 3rem; 
                            background-image: url('/foto_funcionario?funcionario_id=${usuario.funcionario_id}'); 
                            background-size: cover`" :src="`/foto_funcionario?funcionario_id=${usuario.funcionario_id}`" 
                          class="w3-circle w3-border w3-margin-bottom w3-center">
                        </td>
                        <td v-on:click="adicionarRemoverUsuario(usuario.funcionario_id, usuario.adicionado)">{{usuario.funcionario_id}}</td>
                        <td v-on:click="adicionarRemoverUsuario(usuario.funcionario_id, usuario.adicionado)">{{usuario.nome}}</td>
                        <td
                          class="w3-hide-small" 
                          v-on:click="adicionarRemoverUsuario(usuario.funcionario_id, 
                          usuario.adicionado)">
                          {{usuario.nome_empresa_resumido}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <footer class="w3-container conteudo-centralizado">
              <button 
                class="w3-btn w3-theme" 
                id="btn-confirmar-acao" 
                style="margin-top: 10px; margin-bottom:10px"
                @click="mostrarModalInserirUsuarios = false">
                Ok
              </button>
            </footer>
          </div>
        </div>
        <!-- Fim modal inserir responsavel  -->

        <!-- Inicio modal selecionar departamento -->
        <div 
          id="modalInserirDepartamentos" 
          style="display: block"
          v-if="mostrarModalInserirDepartamentos"
          @click="mostrarModalInserirDepartamentos = false"
          class="w3-modal">
          
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span 
                @click="mostrarModalInserirDepartamentos = false"
                class="w3-button w3-display-topright">&times;
              </span>
              <h2 class="texto-vermelho titulo">Departamentos da empresa</h2>
            </header>
            
            <div class="w3-container">
              <div class="w3-col">
                <br>
                <button 
                  class="w3-button w3-theme w3-tiny w3-margin-bottom" 
                  v-on:click="selecionarTodosDepartamentos()">
                  <i class="fa fa-plus"></i>
                </button>
                
                <button 
                  class="w3-button w3-text-theme w3-border w3-tiny w3-margin-bottom"
                  v-on:click="removerTodosDepartamentos()">
                  <i class="fa fa-times"></i>
                </button>
                
                <strong>Selecionar todos</strong>
                <div class="w3-responsive w3-border" style="max-height: calc(100vh - 320px);min-height: 200px;overflow: auto">
                  <table class="w3-table-all">
                    <thead>
                      <th>Código</th>
                      <th>Nome</th>
                    </thead>
                    <tbody>
                      <tr 
                        v-for="(departamento, departamento_index) in departamentos_disponiveis"
                        :key="departamento_index"
                        :class="getClasseDisponivel(departamento.adicionado)"
                        v-on:click="adicionarRemoverDepartamento(departamento.departamento_id, departamento.adicionado)">
                        <td>{{departamento.departamento_id}}</td>
                        <td>{{departamento.nome}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
            <footer class="w3-container conteudo-centralizado">
              <button 
                class="w3-btn w3-theme"
                id="btn-confirmar-acao"
                style="margin-top: 10px; margin-bottom:10px" 
                @click="mostrarModalInserirDepartamentos = false">
                Ok
              </button>
            </footer>
          </div>
        </div>
        <!-- Fim modal selecionar departamento -->

        <!-- Inicio modal detalhe do patrimonio -->
        <div 
          id="modalDetalhePatrimonio" 
          v-if="mostrarModalDetalhePatrimonio"
          @click="mostrarModalDetalhePatrimonio = false" 
          style="display: block" 
          class="w3-modal">
          
          <div class="w3-modal-content w3-animate-zoom">
            <header class="w3-container">
              <span 
                @click="mostrarModalDetalhePatrimonio = false"
                class="w3-button w3-display-topright">&times;
              </span>
              <h2 class="titulo texto-vermelho">Detalhes do patrimônio</h2>
            </header>
            
            <div class="w3-container">
              <div class="w3-col">
                <br>
                  <div 
                    v-show="patrimonio_selecionado.length > 0" 
                    v-for="(patrimonio, patrimonio_index) in patrimonio_selecionado" 
                    :key="patrimonio_index"
                    class="w3-responsive" 
                    style="max-height: calc(100vh - 320px);min-height: 200px;overflow: auto">
                    <table class="w3-table-all w3-stripped">
                      <thead>
                        <tr>
                          <th>Status: {{patrimonio.status}}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Código do patrimônio:</td>
                          <td>{{patrimonio.patrimonio_id}}</td>  
                        </tr>
                        <tr>
                          <td>Empresa:</td>
                          <td>{{patrimonio.empresa_id}} - {{patrimonio.nome_empresa}}</td>  
                        </tr>
                        <tr>
                          <td>Código do produto:</td>
                          <td>{{patrimonio.produto_id}}</td>
                        </tr>
                        <tr>
                          <td>Nome do patrimônio:</td>
                          <td>{{patrimonio.nome}}</td>
                        </tr>
                        <tr>
                          <td>Funcionário responsável:</td>
                          <td v-if="patrimonio.funcionario_responsavel_id != 0">
                            {{patrimonio.funcionario_responsavel_id}} - {{patrimonio.nome_funcionario_responsavel}}
                          </td>
                          <td v-else>Não informado</td>
                        </tr>
                        <tr>
                        <td>Departamento:</td>
                          <td v-if="patrimonio.departamento_id != 0">
                            {{patrimonio.departamento_id}} - {{patrimonio.nome_departamento}}
                          </td>
                          <td v-else>Não informado</td>
                        </tr>
                        <tr>
                          <td>Observação:</td>
                          <td>{{patrimonio.observacao}}</td>
                        </tr>
                        <tr>
                          <td>Data contábil:</td>
                          <td>{{patrimonio.data_contabil}}</td>
                        </tr>
                        <tr>
                          <td>Data da baixa:</td>
                          <td>{{patrimonio.data_baixa}}</td>
                        </tr>
                        <tr>
                          <td>Número da nota:</td>
                          <td>{{patrimonio.numero_nota}}</td>
                        </tr>
                        <tr>
                          <td>Código entrada:</td>
                          <td>{{formatarValor(patrimonio.entrada_id, 0)}}</td>
                        </tr>
                        <tr>
                          <td>Código de plaqueta:</td>
                          <td>{{patrimonio.codigo_plaqueta}}</td>
                        </tr>
                      </tbody>
                    </table><br>
                  </div>
              </div>
            </div>
            
            <footer class="w3-container conteudo-centralizado">
              <button 
                class="w3-btn w3-theme"
                id="btn-confirmar-acao" 
                style="margin-top: 10px; margin-bottom:10px" 
                @click="mostrarModalDetalhePatrimonio = false">
                Ok
              </button>
            </footer>
          </div>
        </div>
        <!-- Fim modal detalhe do patrimonio -->

      </div>
      <div id="carregar_rodape"></div>
    </div>
  </div><!-- verificar-patrimonio -->
</template>

<script>
  import NavMenu from '@/components/Menu';
  import store from '@/ambiente/store';
  import RSessao from '@/components/Rest/RSessao';
  import RPatrimonio from '@/components/Rest/RPatrimonio.js';
  import RFuncionario from '@/components/Rest/RFuncionario.js';
  import RDepartamento from '@/components/Rest/RDepartamento.js'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  
  export default {
    name: 'VerificarPatrimonio',
    components: {
      NavMenu
    },
    data() {
      return {
          api: process.env.API,
          processando: false,
          patrimonio_filtrado: [],
          patrimonio_selecionado: [],
          empresas_autorizadas: [],
          empresas_selecionadas: [],
          usuarios_selecionados: [],
          usuarios_disponiveis_filtrados: [],
          usuarios_disponiveis: [],
          departamentos_disponiveis: [],
          departamentos_disponiveis_filtrados: [],
          departamentos_selecionados: [],
          buscar_fotos_usuarios: false,
          filtro_id: '',
          tipo_filtro: '',
          filtro_usuarios: '',
          selecionar_todos_dp: '',
          processando: false,

          // modais
          mostrarModalInserirEmpresas: false,
          mostrarModalInserirUsuarios: false,
          mostrarModalInserirDepartamentos: false,
          mostrarModalDetalhePatrimonio: false
      }
    },
    methods: {
      async buscarEmpresasAutorizadas(){
        try {
          if (!RSessao.carregouSessao()) {
            await RSessao.buscarDadosCarregarSessao(this.axios);
          }
          this.empresas_autorizadas = await JSON.parse(JSON.stringify(store.state.empresas_autorizadas));
          for (var i = 0; i < this.empresas_autorizadas.length; i++) {
            this.empresas_autorizadas[i].adicionado = true;
            this.empresas_selecionadas.push(this.empresas_autorizadas[i]);
          }
        } catch (error) {
          Biblioteca.exclamar("Erro ao buscar empresas!");
        }
      },
      
      adicionarRemoverEmpresa: function(empresa_id, adicionado){
        if (adicionado){
          for (var i = 0; i < this.empresas_autorizadas.length; i++) {
            if (this.empresas_autorizadas[i].empresa_id == empresa_id){
              this.empresas_autorizadas[i].adicionado = false;
              break;
            }
          }

          for (var i = 0; i < this.empresas_selecionadas.length; i++) {
            if (this.empresas_selecionadas[i].empresa_id == empresa_id){
              this.empresas_selecionadas.splice(i, 1);
              break;
            }
          }
        }else{
          for (var i = 0; i < this.empresas_autorizadas.length; i++) {
            if (this.empresas_autorizadas[i].empresa_id == empresa_id){
              this.empresas_autorizadas[i].adicionado = true;
              this.empresas_selecionadas.push(this.empresas_autorizadas[i]);
              break;
            }
          }
        }
      },
      
      getClasseDisponivel: function(adicionado){
        if (adicionado)
          return 'w3-theme label-clicavel';
        else
          return 'w3-white label-clicavel';
      },
      
      mostrarModalEmpresas: function(){
        this.mostrarModalInserirEmpresas = true;
      },
      
      mostrarModalUsuarios: function(){
        if (this.empresas_selecionadas.length == 0){
          Biblioteca.exclamar("É necessário selecionar empresa(s) para a pesquisa!");
          return;
        }
        this.mostrarModalInserirUsuarios = true;
      },
      
      mostrarModalDepartamentos: function(){
        if (this.empresas_selecionadas.length == 0){
          Biblioteca.exclamar("É necessário selecionar empresa(s) para a pesquisa!");
          return;
        }
        this.mostrarModalInserirDepartamentos = true;
      },
      
      mostrarModalDetalhes: function(patrimonio_id){
        this.patrimonio_selecionado = [];

        for (var i = 0; i < this.patrimonio_filtrado.length; i++) {
          if (this.patrimonio_filtrado[i].patrimonio_id == patrimonio_id){
            this.patrimonio_selecionado.push(this.patrimonio_filtrado[i]);
            break;
          }
        }
        this.mostrarModalDetalhePatrimonio = true;
      },
      
      adicionarRemoverUsuario: function(funcionario_id, adicionado){
        if (adicionado){
          for (var i = 0; i < this.usuarios_selecionados.length; i++) {
            if (this.usuarios_selecionados[i].funcionario_id == funcionario_id){
              this.usuarios_selecionados.splice(i, 1);
              break;
            }
          }

          for (var i = 0; i < this.usuarios_disponiveis.length; i++) {
            if (this.usuarios_disponiveis[i].funcionario_id == funcionario_id){
              this.usuarios_disponiveis[i].adicionado = false;
              break;
            }
          }

          for (var i = 0; i < this.usuarios_disponiveis_filtrados.length; i++) {
            if (this.usuarios_disponiveis_filtrados[i].funcionario_id == funcionario_id){
              this.usuarios_disponiveis_filtrados[i].adicionado = false;
              break;
            }
          }
        }else{
          for (var i = 0; i < this.usuarios_disponiveis.length; i++) {
            if (this.usuarios_disponiveis[i].funcionario_id == funcionario_id){
              this.usuarios_disponiveis[i].adicionado = true;
              break;
            }
          }

          for (var j = 0; j  < this.usuarios_disponiveis_filtrados.length; j++){
            if (this.usuarios_disponiveis_filtrados[j].funcionario_id == funcionario_id){
              this.usuarios_disponiveis_filtrados[j].adicionado = true;
              this.usuarios_selecionados.push(this.usuarios_disponiveis_filtrados[j]);
              break;
            }
          }
        }
      },
      
      adicionarRemoverDepartamento: function(departamento_id, adicionado){
        if (adicionado){
          for (var i = 0; i < this.departamentos_selecionados.length; i++) {
            if (this.departamentos_selecionados[i].departamento_id == departamento_id){
              this.departamentos_selecionados.splice(i, 1);
              break;
            }
          }

          for (var i = 0; i < this.departamentos_disponiveis.length; i++) {
            if (this.departamentos_disponiveis[i].departamento_id == departamento_id){
              this.departamentos_disponiveis[i].adicionado = false;
              break;
            }
          }
        }else{
          for (var i = 0; i < this.departamentos_disponiveis.length; i++) {
            if (this.departamentos_disponiveis[i].departamento_id == departamento_id){
              this.departamentos_disponiveis[i].adicionado = true;
              this.departamentos_selecionados.push(this.departamentos_disponiveis[i]);
              break;
            }
          }
        }
      },
      
      filtrarUsuarios: function(){
        this.usuarios_disponiveis_filtrados = [];
    
        if  (this.filtro_usuarios == '')
          this.usuarios_disponiveis_filtrados = this.usuarios_disponiveis;
        else{
          for (var i = 0; i < this.usuarios_disponiveis.length; i++) {
            if (this.usuarios_disponiveis[i].nome.toUpperCase().indexOf(this.filtro_usuarios.toUpperCase()) > -1){
              this.usuarios_disponiveis_filtrados.push(this.usuarios_disponiveis[i])
            }

            if (this.usuarios_disponiveis[i].funcionario_id == this.filtro_usuarios){
              this.usuarios_disponiveis_filtrados.push(this.usuarios_disponiveis[i])
            }
          }
        }
      },
      
      async buscarFuncionarios() {
        try {
          this.processando = true;
          let retorno = await RFuncionario.buscarUsuarios(this.axios);
          
          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }

          for (var i = 0; i < retorno.dados.length; i++) {
            retorno.dados[i].adicionado = false;
          }

          this.usuarios_disponiveis = retorno.dados;
          this.usuarios_disponiveis_filtrados = retorno.dados;
          this.processando = false;
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },
      
      async buscarPatrimonio(){
        try {
          var funcionario = {};
          var departamento = {};
          var empresa = {};

          if (this.empresas_selecionadas.length == 0){
            Biblioteca.exclamar("É necessário selecionar empresa(s) para a pesquisa!");
            return;
          }

          if(parseInt(this.filtro_id) < 0){
            Biblioteca.exclamar("É necessário inserir um código válido!");
            return;
          }

          this.processando = true;
          this.patrimonio_filtrado = [];
          funcionario.funcionario_id = [];
          empresa.empresa_id = [];
          departamento.departamento_id = [];

          for (var i = 0; i < this.empresas_selecionadas.length; i++){
            empresa.empresa_id.push(this.empresas_selecionadas[i].empresa_id);
          }

          for (var i = 0; i < this.usuarios_selecionados.length; i++){
            funcionario.funcionario_id.push(this.usuarios_selecionados[i].funcionario_id);
          }

          for (var i = 0; i < this.departamentos_selecionados.length; i++) {
            departamento.departamento_id.push(this.departamentos_selecionados[i].departamento_id);
          }
          
          let parametros = {
            filtro_id: this.filtro_id,
            tipo_filtro: this.tipo_filtro,
            empresas_ids: empresa.empresa_id,
            funcionarios_ids: funcionario.funcionario_id,
            departamentos_ids: departamento.departamento_id
          }

          let retorno = await RPatrimonio.buscarPatrimonio(this.axios, parametros);
          
          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }

          this.processando = false;
          this.patrimonio_filtrado = retorno.dados;
          setTimeout(function(){$('html,body').animate({scrollTop: ($("#tabelaPatrimonios")).offset().top});}, 300);
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },

      verificarModalAberto(){
        const el = document.documentElement
        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        } 
      },

      async buscarDepartamentos() {
        try {
          this.processando = true;
          let retorno = await RDepartamento.buscarDepartamentos(this.axios);

          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }

          for (var i = 0; i < retorno.dados.length; i++) {
            retorno.dados[i].adicionado = false;
          }

          this.departamentos_disponiveis = retorno.dados;
          this.processando = false;
        } catch (e) {
           this.processando = false;
           Biblioteca.exclamar(e.message);
        }
      },

      selecionarTodosDepartamentos: function(){
        for (var i = 0; i < this.departamentos_disponiveis.length; i++) {
          this.departamentos_disponiveis[i].adicionado = true;
          this.departamentos_selecionados.push(this.departamentos_disponiveis[i]);
        }
      },

      removerTodosDepartamentos: function(){
        for (var i = 0; i < this.departamentos_disponiveis.length; i++) {
          this.departamentos_disponiveis[i].adicionado = false;
        }
        this.departamentos_selecionados.splice(0, this.departamentos_selecionados.length);
      },

      formatarValor: function(valor, quant_casas_decimais = 2){
        return formatarValorGeral(valor, quant_casas_decimais);
      }
    },

    computed: {
      verificarModal() {
        if (this.mostrarModalInserirEmpresas || 
        this.mostrarModalInserirUsuarios ||
        this.mostrarModalInserirDepartamentos ||
        this.mostrarModalInserirDepartamentos) return true;
        else return false;     
      }
    },
    watch: {
      mostrarModalInserirEmpresas() {
        this.verificarModalAberto();   
      },

      mostrarModalInserirUsuarios() {
        this.verificarModalAberto();   
      },

      mostrarModalInserirDepartamentos() {
        this.verificarModalAberto();   
      },
      
      mostrarModalInserirDepartamentos() {
        this.verificarModalAberto();  
      },                  
    },
    created: function () {
      this.tipo_filtro = 'CP';
      this.buscarEmpresasAutorizadas();
      this.buscarFuncionarios();
      this.buscarDepartamentos();
    },
  }
</script>

<style scoped>
  .w3-modal {
    padding-top: 50px !important;
  } 
  
  .campo-check{
    margin: 20px 0 16px 16px;
    float:left;
  }
  
  .metade {
    border: 1px solid #9c1d1c;
    padding: 5px !important;
    margin-bottom: 20px;    
    }
  
  .titulo{
    border-bottom:1px solid #8d1007;
    font-size: 22px
  }
  
  .metade h5{
    color: #9c1d1c;
    font-weight: bold;
  }
  
  ::-webkit-scrollbar {
      width: 5px;
  }
  
  ::-webkit-scrollbar-track {
    background: #ddd; 
    }
      
  ::-webkit-scrollbar-thumb {
    background: #8d1007; 
  }
    
  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c; 
  }
  
  @media screen and (min-width: 768px){
    .metade {
      width: calc((100% - 20px) / 2) !important;
    }
    .metade:first-of-type{
      margin-right:20px;
    }
  }
  
  @media screen and (max-width: 1199px){
    .metade h5{
      font-size: 16px
    }
    
    .metade label{
      line-height:40px !important;
    }
  }
  
  @media screen and (max-width: 767px){  
    .campo-check{
      margin: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/VerificarPatrimonio.vue